{
  "adobeExperienceCloudNoOrgsSelect": "Sélectionner le compte d’une autre organisation",
  "help": "Aide",
  "newAnnouncement": "A une nouvelle annonce",
  "notification": "Notifications et annonces",
  "profile": "Profil",
  "searchButton": "Rechercher",
  "sidenavMenuCloseTooltip": "Fermer le menu",
  "sidenavMenuOpenTooltip": "Ouvrir le menu",
  "solutionSwitcher": "Passer à une autre solution",
  "unread": "notifications non lues"
}
